<template>
    <form @submit.prevent="handleSubmit" id="team_edit_form">
        <!-- Team Name -->
        <div class="mb-4">
            <label class="form-label form-label-thin">Team Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control form-control-thin" id="name" name="name" ref="name"
                v-model="form.name" placeholder="Team Name" />
        </div>

        <!-- Head Selection with Add User Button -->
        <div class="mb-4">
            <label class="form-label form-label-thin">Head <span class="text-danger">*</span></label>
            <div class="d-flex gap-2">
                <MultiSelect v-model="form.head" :options="members" value-key="external_id" label-key="name"
                    placeholder="Select Head" :multiple="false" class="flex-grow-1"  name="head" id="head" ref="head" />
                <button type="button" class="btn btn-sm btn-outline-primary" @click="openCreateUserModal">
                    <i class="fa fa-plus"></i> Add User
                </button>
            </div>
        </div>

        <!-- Members Selection with Add User Button -->
        <div class="mb-4">
            <label class="form-label form-label-thin">Members <span class="text-danger">*</span></label>
            <div class="d-flex gap-2">
                <MultiSelect v-model="form.members" :options="members" value-key="external_id" label-key="name"
                    placeholder="Select Members" :multiple="true" class="flex-grow-1"  name="members" id="members" ref="members" />
                <button type="button" class="btn btn-sm btn-outline-primary" @click="openCreateUserModal">
                    <i class="fa fa-plus"></i> Add User
                </button>
            </div>
        </div>

        <!-- Description -->
        <div class="mb-4">
            <label class="form-label form-label-thin">Description If Any</label>
            <textarea class="form-control form-control-thin" id="description" name="description" ref="description"
                v-model="form.description" placeholder="Team Description" rows="2"></textarea>
        </div>

        <!-- Modal Footer -->
        <div class="d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-sm btn-outline-secondary hover-white" @click="close">
                <i class="fa fa-times"></i> Cancel
            </button>
            <button type="submit" class="btn btn-primary py-1 px-2 text-light hover-white btn-sm form-submit-btn"
                :disabled="submitting">
                <i class="fa-solid fa-pen fs-12"></i> Update
            </button>
        </div>
    </form>

</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import MultiSelect from '@/components/MultiSelect.vue'

export default {
    name: 'EditTeam',
    components: {
        MultiSelect
    },
    props: {
        externalId: {
            type: String,
            required: true
        }
    },

    emits: ['updated', 'close'],
    data() {
        return {
            form: {
                name: '',
                description: '',
                head: '',
                members: []
            },
            submitting: false,
            loading: false,
            members: []
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            await this.get_members()
            await this.get_team()
        },

        async get_members() {
            const result = await form_api_submit({
                url: 'user/dropdown',
                method: 'GET',
                show_success_toast: false
            })

            if (result.success) {
                this.members = (result.data || []).map(member => ({
                    external_id: member.external_id,          // ← valueKey
                    name: `${member.first_name} ${member.last_name}`, // ← labelKey
                }))
            }
        },

        async get_team() {
            this.loading = true

            const result = await form_api_submit({
                url: `team/${this.externalId}`,
                method: 'GET',
                show_success_toast: false
            })

            if (result.success) {
                const team = result.data.team
                this.form.name = team.name
                this.form.description = team.description ?? ''
                this.form.head = team.get_head?.external_id ?? ''
                this.form.members = (team.get_members || []).map(m => m.external_id)
            }

            this.loading = false
        },
async handleSubmit() {
  this.submitting = true

  try {
    const fd = new FormData()
    fd.append('name', this.form.name)
    fd.append('description', this.form.description)

    if (this.form.head) {
      fd.append('head', this.form.head)
    }

    this.form.members.forEach(id => {
      fd.append('members[]', id)
    })

    const result = await form_api_submit({
      url: `team/update/${this.externalId}`,  // ← was this.external_id
      method: 'POST',
      data: fd,
      curr_form_id: '#team_edit_form'
    })

    if (result.success) {
      this.$emit('updated')   // ← was 'created'
      this.$emit('close')
    }

  } finally {
    this.submitting = false
  }
},

        close() {
            this.$emit('close')
        }
    }
}
</script>